module.exports = __webpack_public_path__ + "static/media/RadiusonesideBlue.65f731a7.svg";